export function getCourseColor(courseCode) {
    let hash = 0;

    for (let index = 0; index < courseCode.length; index++) {
        hash = (hash * 31 + courseCode.charCodeAt(index)) % 10;
    }

    return hash;
}
